export default __webpack_public_path__ + "static/media/upcoming-webinar.f64ab9c2.svg";